module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0123.png.bfa22c94.jpg";